import { toUtcAdjusted } from '@noor/lib';
import type { TransactionListSearch } from '../model/list-params';

/** Query of `GET admin/transactions`. */
export interface TransactionsListFilter {
  limit: number;
  skip: number;
  from_date: string;
  till_date: string;
  courier_id?: string | undefined;
  client_id?: string | undefined;
  vendor_id?: string | undefined;
  type?: string | undefined;
  display_id?: string | undefined;
  status?: string | undefined;
  bonus_id?: string | undefined;
  foul_id?: string | undefined;
}

/** Query of every report export (the list filter minus paging, plus `stage`). */
export interface TransactionsReportPayload {
  from_date: string;
  till_date: string;
  courier_id?: string | undefined;
  client_id?: string | undefined;
  vendor_id?: string | undefined;
  type?: string | undefined;
  stage?: string | undefined;
  status?: string | undefined;
}

/**
 * The day window both the list and the exports send (cpanel): the start day's
 * adjusted midnight through the END of the end day (`+1 day`, exclusive).
 */
function dayWindow(search: Pick<TransactionListSearch, 'start_date' | 'end_date'>) {
  return {
    from_date: toUtcAdjusted(search.start_date).toISOString(),
    till_date: toUtcAdjusted(search.end_date).add(1, 'day').toISOString(),
  };
}

/** Build the list query from URL params (cpanel `buildTransactionsListFilter`). */
export function buildTransactionsListFilter(
  search: TransactionListSearch,
): TransactionsListFilter {
  return {
    limit: search.pageSize,
    skip: (search.page - 1) * search.pageSize,
    ...dayWindow(search),
    courier_id: search.courier_id,
    client_id: search.client_id,
    vendor_id: search.vendor_id,
    type: search.type,
    display_id: search.search,
    status: search.status,
    bonus_id: search.bonus_id,
    foul_id: search.foul_id,
  };
}

/** Build the export payload from URL params (cpanel `handleDownload`). */
export function buildTransactionsReportPayload(
  search: TransactionListSearch,
): TransactionsReportPayload {
  return {
    ...dayWindow(search),
    courier_id: search.courier_id,
    client_id: search.client_id,
    vendor_id: search.vendor_id,
    type: search.type,
    stage: search.stage,
    status: search.status,
  };
}
